module.exports = __webpack_public_path__ + "15_hair_brown.796cfeab.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/15_hair_brown.png
// module id = NbO2
// module chunks = 0